import { Injectable } from '@angular/core';
import { Product, Category, CategoryResponse, CategoryItems, Paging} from './product';
import { Query } from './query';
import { HttpClient, HttpHeaders, HttpParams , HttpErrorResponse, HttpResponse} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '../../environments/environment';

import { from } from 'rxjs/observable/from';
import { of } from 'rxjs/observable/of';
import {switchMap, mergeMap,flatMap, take, mergeAll, combineAll, map, toArray, mapTo} from 'rxjs/operators';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toArray';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/mapTo';

// import 'rxjs/add/observable/of';
// import 'rxjs/add/observable/from';


import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { finalize, tap } from 'rxjs/operators';



@Injectable()
export class ProductsService {

  private apiUrl: string  = '/api';
  private rootUrl: string  = '';
  private imageBase: string = '/Podium_Browser/'
  private categories: Category[] = [];
  private products: Product[];
  private categoryResponseCache:CategoryResponse;
  private fileData: string = 'http://v3.pdm-plants-textures.com/filedatamin.json';

  constructor(private http: HttpClient) {
    this.apiUrl = `${environment.serverUrl}/api`;
    this.rootUrl = environment.serverUrl;
    this.imageBase = `${environment.imageBase}/Podium_Browser/`;
    this.fileData = environment.fileData;
  }

  getProducts(filter: any): Observable<any>{

    const httpOptions = {
      params: filter
    };

     return this.http.get(`${this.apiUrl}/files`, httpOptions).pipe(
      catchError(this.handleError)
    );

  }

  getProductById(id: any): Observable<any>{


     return this.http.get(`${this.apiUrl}/files/${id}`).pipe(
      catchError(this.handleError)
    );

  }

  getAllProductsStatic(): Observable<any>{
    return this.http.get(this.fileData).pipe(
     catchError(this.handleError)
   );
  }

  getAllProducts(filter: any): Observable<any>{

    filter.limit = 1000;

    const httpOptions = {
      params: filter
    };

     return (this.products)? of(this.products) : this.http.get(`${this.apiUrl}/files`, httpOptions).pipe(
       tap((results:any) => this.products = results.data),
      catchError(this.handleError)
    );

  }

  getTitles(filter: any): Observable<any>{

    const httpOptions = {
      params: filter
    };

     return this.http.get(`${this.apiUrl}/titles`, httpOptions).pipe(
      catchError(this.handleError)
    );

  }

  getCatories(filter: Query): Observable<CategoryResponse>{

    const httpOptions = {
      params: this.queryToSearchParams(filter)
    };




     return (this.categoryResponseCache)? of(this.categoryResponseCache) : this.http.get<CategoryResponse>(`${this.apiUrl}/categories`, httpOptions)
     .pipe(
      tap((result:any) => {

        // There may be other events besides the response.
        if (result.data) {
          this.categoryResponseCache = result;

          this.categories = result.data;
        }
      }),
      catchError(this.handleError)
    );

  }

  getCatoriesTopLevel():  Observable<Category[]> {
  return this.getCatories({})
  .map((results: CategoryResponse) => {
    // Results.data is an array
    return results.data.filter((item: Category) => {
          if(item.parents && item.parents.length ){
           return item.parents[0]['parent_id'] === 0;
          } else {
            return false;
          }
  })
})


  }

  getCatoriesChildren(id: number):  Observable<Category[]> {

    return this.getCatories({})
    .map((results: CategoryResponse) => {
      // Results.data is an array
      // filter out for categories in question
      return results.data.filter((item: Category) => {
        // 1st checks for any child categrories
            if(item.parents && item.parents.length && item.parents[0]['parent_id'] === id){
             return true;
            } else if ( item.id === id && item.parents[0]['parent_id'] === 0 ){
              // if its this category and theres no child ie. group_id = 0 or top Level
              // must be a child category id passed in
              return true;
            } else{
              return false;
            }
    })
  })

    }

    getCatoriesSingle(id: number): Observable<Category> {

      return this.getCatories({})
      .map((results: CategoryResponse) => {
        // Results.data is an array
        return results.data.find((item: Category) => {
              return item.id === id;
            })
      })

      }

    private compareLengthFn = (a, b) => {

        if (a.items.length < b.items.length)
          return -1;
        if (a.items.length > b.items.length)
          return 1;
        return 0;
      };

    getCategorySubItems(filter: Query, idSet: boolean): Observable<CategoryItems[]> {

      // if we have a parent id then get sub categories, if not just return the top level categories
      const subCategoryChildren = (idSet)? this.getCatoriesChildren(filter.category) : this.getCatoriesTopLevel();


      return subCategoryChildren
      .pipe(


        flatMap((items:CategoryItems[])=> {

          return from(items).pipe(
            flatMap((item:CategoryItems)=> {


              const filterObj: Query = {
                category:item.id,
                type: filter.type || '',
                limit: filter.limit || 1000
              };

              if(filter.recent) filterObj.recent = filter.recent;

              if(!idSet){
                 filterObj.limit = 10;
                }

              return this.getProducts(filterObj)
              .map(results => {
                const categoryItem: CategoryItems = {
                        id: item.id,
                        category_name: item.category_name,
                        title: item.title,
                        group_id: item.group_id,
                        items: results.data
                      };
                return categoryItem;
              })



          }),
          toArray()
        )
        })



      )

    }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an ErrorObservable with a user-facing error message
    return new ErrorObservable(
      'Something bad happened; please try again later.');
  };




  queryToSearchParams(filter: Query) {
    let params = new HttpParams();

    if (filter.name) {
      params = params.append('n', filter.name.toString());
    }

    if (filter.page) {
      params = params.append('page', filter.page.toString());
    }

    if (filter.limit) {
      params =  params.append('limit', filter.limit.toString());
    }

    if (filter.type) {
      params =  params.append('type', filter.type.toString());
    }

    if (filter.category) {
      params = params.append('category', filter.category.toString());
    }

    if (filter.s) {
      params =  params.append('s', filter.s.toString());
    }

    if (filter.recent) {
      params =  params.append('recent', filter.recent.toString());
    }

    return params;
  }

}



// WEBPACK FOOTER //
// ./src/app/products/products.service.ts



// WEBPACK FOOTER //
// ./src/app/products/products.service.ts